import type { FacebookEmbed, SiteContent } from './types';

export const SUGARLOAF_FACEBOOK_PAGE_URL = 'https://www.facebook.com/p/Sugarloaf-Golden-Retrievers-61576625395815/';

export function isFacebookSectionVisible(content: Pick<SiteContent, 'facebook' | 'sections'>): boolean {
  return content.facebook.enabled && !content.sections.hidden.includes('facebook');
}

export function setFacebookSectionVisibility(content: SiteContent, visible: boolean): SiteContent {
  const hidden = visible
    ? content.sections.hidden.filter((section) => section !== 'facebook')
    : content.sections.hidden.includes('facebook')
      ? content.sections.hidden
      : [...content.sections.hidden, 'facebook' as const];
  return {
    ...content,
    facebook: { ...content.facebook, enabled: visible },
    sections: { ...content.sections, hidden },
  };
}

export function normalizeFacebookUrl(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    const hostname = url.hostname.toLowerCase();
    if (url.protocol !== 'https:' || (hostname !== 'facebook.com' && !hostname.endsWith('.facebook.com'))) return null;
    url.hash = '';
    return url.toString();
  } catch {
    return null;
  }
}

export function facebookPluginUrl(item: Pick<FacebookEmbed, 'kind' | 'url'>): string | null {
  const url = normalizeFacebookUrl(item.url);
  if (!url) return null;
  const plugin = item.kind === 'video' ? 'video.php' : 'post.php';
  const parameters = new URLSearchParams({ href: url, width: '720', show_text: item.kind === 'post' ? 'true' : 'false' });
  return `https://www.facebook.com/plugins/${plugin}?${parameters.toString()}`;
}
